import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: 63px;\n\n  @media (min-width: ",
        ") {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  background: linear-gradient(45deg, ",
        " 0%, ",
        " 100%);\n  border-radius: 30px 30px 0 0;\n  justify-content: space-between;\n  align-items: center;\n  padding: 36px 24px;\n\n  p {\n    font-family: ",
        ";\n    ",
        "\n    font-weight: 400;\n    color: ",
        ";\n    margin: 0;\n    margin-bottom: 24px;\n    text-align: center;\n  }\n\n  @media (min-width: ",
        ") {\n    p {\n      ",
        "\n      width: 327px;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding: 60px;\n\n    p {\n      text-align: inherit;\n      margin-bottom: 0;\n      font-family: ",
        ";\n      ",
        "\n      width: auto;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  padding: 36px 24px;\n  flex: 1;\n\n  @media (min-width: ",
        ") {\n    padding: 40px 60px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 26px;\n\n  p {\n    margin: 0;\n    margin-bottom: 18px;\n    font-family: ",
        ";\n    color: white;\n    ",
        "\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  flex-basis: 0;\n  padding-top: 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  width: 25%;\n\n  p {\n    margin: 0;\n    margin-bottom: 18px;\n    font-family: ",
        ";\n    color: white;\n    ",
        "\n    font-weight: 700;\n  }\n\n  div {\n    display: flex;\n    flex-direction: column;\n\n    a {\n      color: white;\n      ",
        "\n      font-weight: 400;\n      font-family: ",
        ";\n      text-decoration: none;\n      margin-bottom: 5px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-top: 24px;\n  text-align: center;\n\n  span {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-weight: 400;\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  flex: 1 1 65px;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  margin-top: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  row-gap: 10px;\n  cursor: pointer;\n  border-left: ",
        ";\n\n  span {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-style: normal;\n    ",
        "\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  margin-right: ",
        ";\n\n  img.apps {\n    width: 146px;\n  }\n\n  img {\n    cursor: pointer;\n  }\n\n  @media (min-width: ",
        ") {\n    img.apps {\n      width: ",
        ";\n    }\n  }\n\n  // TOFix\n\n  @media only screen and (max-width: 375px) and (min-width: 290px) {\n    img.apps {\n      width: 119px;\n    }\n  }\n\n  @media only screen and (max-width: 289px) and (min-width: 0) {\n    img.apps {\n      width: 80px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  @media (min-width: ",
        ") {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { breakpoints, colors, fonts, pxToCssFont, pxToCssFontSize, pxToRem } from "@vfit/shared/themes";
export var FooterContainer = styled.footer.withConfig({
    componentId: "sc-58d2fa9d-0"
})(_templateObject(), breakpoints.desktop);
export var FooterTopContainer = styled.div.withConfig({
    componentId: "sc-58d2fa9d-1"
})(_templateObject1(), colors.$820000, colors.$e60000, fonts.regular, pxToCssFont(20, 28), colors.$ffffff, breakpoints.tablet, pxToCssFont(20, 28), breakpoints.desktop, fonts.light, pxToCssFont(30, 38));
export var FooterBottomContainer = styled.div.withConfig({
    componentId: "sc-58d2fa9d-2"
})(_templateObject2(), colors.$0d0d0d, breakpoints.desktop);
export var FooterBottomContent = styled.div.withConfig({
    componentId: "sc-58d2fa9d-3"
})(_templateObject3(), colors.$bebebe, fonts.regular, pxToCssFontSize(20));
export var FooterLinks = styled.div.withConfig({
    componentId: "sc-58d2fa9d-4"
})(_templateObject4());
export var FooterLinksCol = styled.div.withConfig({
    componentId: "sc-58d2fa9d-5"
})(_templateObject5(), fonts.regular, pxToCssFontSize(20), pxToCssFontSize(18), fonts.regular);
export var FooterCopyright = styled.div.withConfig({
    componentId: "sc-58d2fa9d-6"
})(_templateObject6(), colors.$bebebe, fonts.regular, pxToCssFontSize(18));
export var FooterMobileLinks = styled.div.withConfig({
    componentId: "sc-58d2fa9d-7"
})(_templateObject7());
export var FooterMobileLink = styled.div.withConfig({
    componentId: "sc-58d2fa9d-8"
})(_templateObject8(), function(param) {
    var borderLeft = param.borderLeft;
    return borderLeft ? "1px solid #BEBEBE" : "none";
}, colors.$bebebe, fonts.regular, pxToCssFont(16, 22));
export var FooterButton = styled.button.withConfig({
    componentId: "sc-58d2fa9d-9"
})(_templateObject9(), function(param) {
    var marginRight = param.marginRight;
    return marginRight ? "".concat(marginRight, "px") : 0;
}, breakpoints.desktop, function(param) {
    var imageWidth = param.imageWidth;
    return pxToRem(imageWidth || 146);
});
export var FooterAppWrapper = styled.div.withConfig({
    componentId: "sc-58d2fa9d-10"
})(_templateObject10(), breakpoints.desktop, function(param) {
    var height = param.height;
    return height ? pxToRem(height) : "inherit";
});
